import React from "react";
import { Route, Routes } from "react-router-dom";
import { Header } from "../components/layout/Header";
import { Home } from "../components/pages/Home";
import { Footer } from "../components/layout/Footer";
import { ADESIONECL, CAMPAGNE, DETTAGLIOINVITOSOLLECITOCL, FAQ, INFOCOLONRETTO, INVITISOLLECITICL, LOGIN, PROFILO, RIFIUTOCL, ROOT, POSTLOGINLANDING, SCREENINGCOLONRETTO, STRUTTURE, ESITI, PAGENOTFOUND, RICEVIADOMICILIO, MODIFICAINDIRIZZOSPEDIZIONE, ESITICL, PRIVACY, CONTATTI } from "../global/urlMapping";
import { Campagne } from "../components/pages/Campagne";
import { InfoColonRetto } from "../components/pages/ScreeningColonRetto/InfoColonRetto";
import { ScreeningColonRetto } from "../components/pages/ScreeningColonRetto/ScreeningColonRetto";
import { Login } from "../components/pages/Login";
import { PostLoginLanding } from "../components/pages/PostLoginLanding";
import { Profilo } from "../components/pages/Profilo";
import { Esiti } from "../components/pages/Esiti";
import { InvitiSolleciti } from "../components/pages/InvitiSolleciti";
import { DettaglioInvitoSollecitoCL } from "../components/pages/ScreeningColonRetto/DettaglioInvitoSollecitoCL";
import { RifiutoCL } from "../components/pages/ScreeningColonRetto/RifiutoCL";
import { Strutture } from "../components/pages/ScreeningColonRetto/Strutture";
import { AdesioneCL } from "../components/pages/ScreeningColonRetto/AdesioneCL";
import { PageNotFound } from "../components/pages/PageNotFound";
import { RiceviADomicilio } from "../components/pages/ScreeningColonRetto/RiceviADomicilio";
import { ModificaIndirizzoSpedizione } from "../components/pages/ScreeningColonRetto/ModificaIndirizzoSpedizione";
import { EsitiCL } from "../components/pages/ScreeningColonRetto/EsitiCL";
import { ComingSoon } from "../components/pages/ComingSoon";
import { FaqMultiAsl } from "../components/pages/FaqMultiAsl";
import { PrivacyMultiAsl } from "../components/pages/PrivacyMultiAsl";
import { Contatti } from "../components/pages/Contatti";

export const Switch = () => (
    (process.env.REACT_APP_ENV_TYPE === 'sviluppo' || process.env.REACT_APP_ENV_TYPE === 'integrazione' || process.env.REACT_APP_ENV_TYPE === 'produzione') ?
        <div className="switchClass">
            <Header />
            <main className="routesClass">
                <Routes>
                    <Route exact path={ROOT} element={<Home />} />
                    <Route exact path={POSTLOGINLANDING} element={<PostLoginLanding />} />
                    <Route exact path={PRIVACY} element={<PrivacyMultiAsl />} />

                    <Route exact path={FAQ} element={<FaqMultiAsl />} />
                    <Route exact path={CONTATTI} element={<Contatti />} />
                    <Route exact path={LOGIN} element={<Login />} />

                    <Route exact path={PROFILO} element={<Profilo />} />
                    <Route exact path={CAMPAGNE} element={<Campagne />} />
                    <Route exact path={ESITI} element={<Esiti />} />


                    <Route exact path={SCREENINGCOLONRETTO} element={<ScreeningColonRetto />} />
                    <Route exact path={INFOCOLONRETTO} element={<InfoColonRetto />} />
                    <Route exact path={INVITISOLLECITICL} element={<InvitiSolleciti campagna={"CL"} />} />
                    <Route exact path={DETTAGLIOINVITOSOLLECITOCL} element={<DettaglioInvitoSollecitoCL />} />
                    <Route exact path={RIFIUTOCL} element={<RifiutoCL />} />
                    <Route exact path={STRUTTURE} element={<Strutture />} />
                    <Route exact path={RICEVIADOMICILIO} element={<RiceviADomicilio />} />
                    <Route exact path={MODIFICAINDIRIZZOSPEDIZIONE} element={<ModificaIndirizzoSpedizione />} />
                    <Route exact path={ESITICL} element={<EsitiCL />} />


                    <Route exact path={ADESIONECL} element={<AdesioneCL />} />

                    <Route path={PAGENOTFOUND} element={<PageNotFound />} />

                    { /*
                <Route exact path={SCREENINGMAMMOGRAFICO} element={<ScreeningMammografico />} />
                <Route exact path={INFOMAMMOGRAFICO} element={<InfoMammografico />} />             
                <Route exact path={GESTIONEAPPUNTAMENTI} element={<GestioneAppuntamenti />} />
                <Route exact path={SPOSTAAPPUNTAMENTO} element={<SpostaAppuntamento />} />
                */}

                </Routes>
            </main>
            <Footer />
        </div>
        :
        <ComingSoon />
);